<template>
  <div class="container">
    <topHeader return-path="PersonInfo" title="用户协议"></topHeader>
    <div class="userInfo-container">
      <div class="detail-content">
        <div
          class="detail-items"
          @click="
            toPage({
              name: 'PrivacyPolicy'
            })
          "
        >
          <div style="color: #333">个人信息协议</div>
          <img
            class="menu-items-arrow"
            src="@/assets/images/rightImg.png"
            alt
          />
        </div>
        <CommonBorder></CommonBorder>
        <div
          v-if="isShowBtn"
          class="detail-items"
          @click="
            toPage({
              name: 'FacePolicy'
            })
          "
        >
          <div style="color: #333">生物识别协议</div>
          <img
            class="menu-items-arrow"
            src="@/assets/images/rightImg.png"
            alt
          />
        </div>
        <CommonBorder v-if="isShowBtn"></CommonBorder>
      </div>
    </div>
  </div>
</template>

<script>
import CommonBorder from '@/components/commonBorder';

import topHeader from '@/components/topHeader';
export default {
  components: { topHeader, CommonBorder },
  data() {
    return {
      isShowBtn: null
    };
  },
  async created() {
    await this.$store.dispatch('user/getInfo');
    this.isShowBtn = JSON.parse(
      sessionStorage.getItem('personInfo')
    ).userAuths.some((item) => item.channel === 0 && item.type === 1);
  },
  methods: {
    toPage(name) {
      this.$router.push(name);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #f7f7f7;
  .userInfo-container {
    flex: 1;
    .userInfo-content {
      background: #f3f3f3;
      display: flex;
      flex-direction: row;
      align-items: center;
      box-sizing: border-box;
      padding: 24px 16px 20px;
    }
    .detail-content {
      background: #fff;
      margin-top: 10px;
      font-size: 16px;
      .detail-items {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 45px;
        box-sizing: border-box;
        padding: 0 16px;
        justify-content: space-between;
        img {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
}
</style>
